export function useWindowCustomEvents() {
  const c2bClicked = (
    product: ProductViewModel | undefined,
    selectedVariant: SimpleProductVariantViewModel | undefined,
  ) => {
    if (!product || !selectedVariant) {
      return;
    }

    document.documentElement.dispatchEvent(
      new CustomEvent('c2b-clicked', { bubbles: true, detail: { product, selectedVariant } }),
    );
  };

  const storeLocatorClicked = (
    product: ProductViewModel | undefined,
    selectedVariant: SimpleProductVariantViewModel | undefined,
  ) => {
    if (!product || !selectedVariant) {
      return;
    }

    document.documentElement.dispatchEvent(
      new CustomEvent('store-locator-clicked', { bubbles: true, detail: { product, selectedVariant } }),
    );
  };

  return {
    c2bClicked,
    storeLocatorClicked,
  };
}
